import React from 'react';
import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

const HtmlTooltip: React.FC<TooltipProps> = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.grey[900],
    maxWidth: 400,
    fontSize: theme.typography.pxToRem(12),
    padding: '12px',
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: theme.shadows[8],
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
    '&::before': {
      border: `1px solid ${theme.palette.divider}`,
    },
  },
}));

export default HtmlTooltip;
